module.exports = __webpack_public_path__ + "static/slide-2-5c05ea2c60516194af6829d243822570.jpg";